import { get, orderBy } from 'lodash-es';

export function getSortedInventories(inventories, order, withDeliveryFees = false) {
  return orderBy(
    inventories.filter(inventory =>
      withDeliveryFees
        ? get(inventory, 'deliveryFee') || get(inventory, 'deliveryType') === 'Free'
        : !get(inventory, 'deliveryFee') && get(inventory, 'deliveryType') !== 'Free'
    ),
    [inventory => get(inventory, 'prices.advertisedPrice', 0) + get(inventory, 'deliveryFee', 0)],
    [order]
  );
}

export function getSortedInventoriesWithDeliveryFees(inventories, order) {
  const sortedIncentivesWithDeliveryFees = getSortedInventories(inventories, order, true);
  const sortedIncentives = getSortedInventories(inventories, order);

  return [...sortedIncentivesWithDeliveryFees, ...sortedIncentives];
}
